import React, { useState } from "react"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { createPrintRequest } from "utils"
import classes from "./ShiftCashierHistoryPrintButton.module.scss"

const ShiftCashierHistoryPrintButton = props => {
  const { selectedShift } = props

  const [t] = useTranslation()

  const printers =
    useSelector(state => state.printers)

  const { fullName, mobilePhone } =
    useSelector(state => state.userAccountInfo)

  const [loading, setLoading] = useState(false)

  const handlePrint = async () => {
    const printerIndex =
      printers.findIndex(printer => printer.forShiftReport)

    if (printerIndex === -1) {
      toast.error(
        t("هیچ_پرینتری_یافت_نشد_لطفا_در_قسمت_نتظیمات_پرینتر_گزینه_ی_پرینت_شیفت_را_برای_یک_پرینتر_فعال_کنید")
        , { autoClose: false }
      )

      return
    }

    const printerSettings = printers[printerIndex]

    setLoading(true)

    const printData = {
      ...selectedShift,
      fullName,
      mobilePhone
    }

    const request = {
      printType: "shift",
      printerIndex,
      printData,
      printerSettings,
      saveToFailedPrints: false
    }

    try {
      createPrintRequest(request)
    } catch (err) {
      console.log(err)
    }

    setLoading(false)
  }

  return (
    <div className={classes["footer"]}>
      <Button
        loading={loading}
        onClick={handlePrint}
      >
        {t("پرینت_شیفت")}
      </Button>
    </div>
  )
}

export default ShiftCashierHistoryPrintButton